<template>
    <div class="Media">
        <div class="InstructionsMobile" v-if="intructions_step <= 3">
            <div class="InstructionsMobile__backbutton" @click="backInstructions()" v-show="intructions_step > 0"></div>
            <div class="InstructionsMobile__step first" v-if="intructions_step == 0">
                <img class="InstructionsMobile__logo" src="@/commons/images/meneath_titre_en.png" alt="meneath"/>
                <!-- <div class="InstructionsMobile__title" >Select your subtitle preference</div> -->
                <button class="InstructionsMobile__subtitle-select option0" @click="changeSubtitles(0)">No subtitles</button>
                <button class="InstructionsMobile__subtitle-select option1" @click="changeSubtitles(1)">English subtitles</button>
                <button class="InstructionsMobile__subtitle-select option2" @click="changeSubtitles(2)">Sous-titres en français</button>
                <div class="InstructionsMobile__description">The audio of the video will be in&nbsp;English.</div>
                <button class="next" @click="nextInstructions()"  v-if="subtitles != null" >Next</button>
            </div>
            <div class="InstructionsMobile__step" v-if="intructions_step == 1">
                <img class="InstructionsMobile__logo" src="@/commons/images/meneath_titre_en.png" alt="meneath">
                <div class="InstructionsMobile__title" >Turn up the volume on both devices.</div>
                <img class="help-img" src="@/commons/images/cta_volume.png">
                <div class="InstructionsMobile__description">Audio will be played from both devices.</div>
                <button class="next" @click="nextInstructions()">Next</button>
            </div>
            <div class="InstructionsMobile__step" v-if="intructions_step == 2">
                <img class="InstructionsMobile__logo" src="@/commons/images/meneath_titre_en.png" alt="meneath">
                <div class="InstructionsMobile__title" >Hold your phone horizontally.</div>
                <img class="help-img" src="@/commons/images/cta_rotate.png">
                <button class="next landscape" @click="nextInstructions()">Next</button>
            </div>
            <div class="InstructionsMobile__step" v-if="intructions_step == 3">
                <img class="InstructionsMobile__logo" src="@/commons/images/meneath_titre_en.png" alt="meneath">
                <div class="InstructionsMobile__title" >Hold your phone in front of the screen.</div>
                <div class="InstructionsMobile__description">Ensure the entire screen is visible on your phone.</div>
                <img class="help-img" src="@/commons/images/cta_hold.png">
                <button class="next landscape" @click="nextInstructions()">Next</button>
            </div>
        </div>
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Media__container">
                <div class="Media__pausebutton" @click="onUserPauseVideo()" v-if="!sync && cue < 1170" ></div>
                <video class="Media__camera" ref="stream" autoplay playsinline v-show="intructions_step >= 4"></video>
                <video class="Media__movie" ref="movie" playsinline >
                    <source 
                        :src="'/static/foreground_'+ subtitles +'.mov'" 
                        type='video/mp4; codecs="hvc1"'>
                    <source 
                        :src="'/static/foreground_'+ subtitles +'.webm'" 
                        type="video/webm"> 
                </video>
                 
                <div class="Media__frame"> 
                    <!-- <img :src="require('@/commons/images/frame.png')"> -->
                </div>  
                <Transition name="border">
                    <div class="Media__border" v-if="intructions_step == 4 || showFrame()"> 
                        <img :src="require('@/commons/images/frame_mobile.png')">
                    </div>  
                </Transition>
               
                <div class="Media__step5" v-if="intructions_step == 4">
                    <div class="Media__description">When this frame appears on your phone, align it with the frame on the other screen to play the augmented content.</div>
                    <div class="Media__button" @click="nextInstructions()">Next</div>  
                </div>
                <div class="Media__pause" v-if="intructions_step > 4 && sync">
                    <div class="Media__description">Tapping the screen on your phone will pause the experience. To resume the experience, tap the screen on your phone again.</div>
                    <div class="Media__button" @click="onClick()">Play</div>
                </div>
                <!-- <div class="Media__button" @click="onClick()" v-if="sync">Play</div> -->
            </div>
        </transition>
        <div class="Media__credits" v-if="cue >= 1170">
            <Credits/>
        </div>
        <div class="Media__stopped"  v-if="stopped">Projection stopped!</div>
        <!-- <div class="Media__cue"> hevc-compressor | webm-compressor : {{ cue }}</div> -->
    </div>
</template>

<script>

import { Howl, Howler } from 'howler'
import Credits from '@/components/projection/Credits'

export default {

    name: 'Media',
    components: { Credits },
    data: ()=>({
        is_playing: false,
        sync: true,
        ready: false,
        stopped: false,
        delay: 4,
        loop: 0,
        cue: 0,
        intructions_step: 0,
        subtitles: null
    }), 

    computed: {
        sync_time() { return this.$store.getters['socket/sync_time'] },
        start_movie() { return this.$store.getters['socket/start_movie'] },
        master_leave() { return this.$store.getters['socket/master_leave'] },
    },

    watch: {
        start_movie(nw, od) {
            console.log(nw);
            if(nw == true)
                this.isStarted()
        },
        master_leave(nw, od){
            this.stopped = true
            this.pauseVideo()
            // this.$refs.movie.removeEventListener('play', this.computeFrame )
            // this.$id = this.$sound.pause()
        },
        sync_time(nw, od) {

            console.log(nw);

            // 66.534685
            // const movie_cue = Math.floor((this.$refs.movie.currentTime * 10000))/10000
            // if(this.loop == 0) {
               
            const utc = Date.now()-nw.utc
            const adj = utc/1000
            const cue = nw.time + 0 

            this.cue = cue
            this.$refs.movie.currentTime = cue
            // this.$sound.seek(cue, this.$id)
            // }

            // this.loop += 1
            // if(this.loop ==10) 
            //     this.loop = 0

            // const diff = Math.abs(nw.time - this.$refs.movie.currentTime)
            // // console.log(diff + ' == ');

            // const cue = nw.time + .2    
            // if(diff > 1) {
            //     this.$refs.movie.currentTime = cue
            //     this.$sound.seek(cue, this.$id)
            // }      
        },
    },

    beforeDestroy() {
        this.$socket.emit('userLeaveRoom', this.$room)   
    },
    created(){
        this.$room = this.$route.params.room ? this.$route.params.room : 350
        this.$video = this.$route.params.video ? this.$route.params.video : 'media-640'
    },
    mounted : async function (){

        window.addEventListener('resize', this.onResize)
        window.addEventListener('orientationchange', this.onResize)

        document.addEventListener('visibilitychange', this.checkVisibility)
        // window.addEventListener('focus', this.focus)
        window.addEventListener('blur', this.blur)


        this.$constraints = window.constraints = { audio: false, video: { facingMode: "environment" } }
        
        try {    
            const stream = await navigator.mediaDevices.getUserMedia(this.$constraints)
            this.handleSuccess(stream);
            this.init()
            // e.target.disabled = true;
        } catch (e) {
            // handleError(e);
        }
    },

    methods: {

        blur() {
            // window.alert('blur')
            this.pauseVideo()
            this.$socket.emit('userLeaveRoom', this.$room) 
        },
        checkVisibility: async function (){

            this.pauseVideo()

            // const constraints = window.constraints = { audio: false, video: { facingMode: "environment" } }
            try {    
                const stream = await navigator.mediaDevices.getUserMedia(this.$constraints)
                this.handleSuccess(stream);

                // this.init()
                // e.target.disabled = true;

            } catch (e) {

                // handleError(e);
            }



            // window.alert('checkvisibility')

            // const reload = this.$router.resolve({ query: { forceReload: undefined } })
            // window.location.href = "https://memeath-v2.dpt.media/media/"+ this.$room + reload.href
        },

        onClick() {
            this.sync = false
            this.isStarted()
            this.$socket.emit('startProjection', { room: this.$room, used: true, subtitles: this.subtitles })
        },
        onUserPauseVideo() {
            // if(this.sync) return;

            this.sync = true
            this.$refs.movie.pause()
            this.$socket.emit('userLeaveRoom', this.$room)   
        },
        pauseVideo() {
            this.sync = true
            this.$refs.movie.pause()
        },

        isStarted() {

            // TweenMax.delayedCall(.2, ()=> this.$refs.movie.play())

            this.$refs.movie.play()

            // this.$refs.movie.addEventListener('play', this.computeFrame )
            // window.requestAnimationFrame(this.computeFrame)

            // this.$refs.movie.addEventListener('play', () => {
            //     this.width = this.$refs.movie.videoWidth
            //     this.height = this.$refs.movie.videoHeight 
            //     // this.timerCallback()
            // }, false);

            // this.$id = this.$sound.play()
            // this.$sound.seek(0, this.$id)
        },
        enter(done) {
            done()
        },
        leave(done) {
            done()
        },  
        handleSuccess(stream) {
            const video = this.$refs.stream
            const videoTracks = stream.getVideoTracks()
            video.srcObject = stream
        },
        init() {

            // this.$c1 = document.getElementById('output-canvas')
            // this.$ctx1 = this.$c1.getContext('2d')
            // this.$c_tmp = document.createElement('canvas');
            // this.$c_tmp.setAttribute('width', 1080)
            // this.$c_tmp.setAttribute('height', 608)
            // this.$ctx_tmp = this.$c_tmp.getContext('2d');

            this.onResize()

            // this.$sound = new Howl({
            //     src: [require('@/commons/sound/sound.mp3')],
            //     // autoplay: true,
            //     volume: 1
            // })
            TweenMax.delayedCall(this.delay, ()=>{
                this.$refs.movie.muted = false
                // this.$id = this.$sound.play()
                if(this.$socket.connected)
                    this.$socket.emit('joinSession', this.$room, 'visitor')
            })
        },
        nextInstructions() {
            this.intructions_step++;
            console.log("next:" + this.intructions_step);
        },
        backInstructions() {
            this.intructions_step--;
            console.log("back:" + this.intructions_step);

            if(this.intructions_step <= 0)  this.subtitles = null;
        },
        changeSubtitles(type) {
            this.subtitles = type;

            this.$refs.movie.pause();
            this.$refs.movie.load();

            let elements = document.querySelectorAll('.InstructionsMobile__subtitle-select');
            elements.forEach((element) => {
                element.classList.remove('selected');
            });

            let choice = document.querySelector('.option' + type);
            choice.classList.add('selected');
        },
        showFrame() {
            let cue = this.cue;
            if((cue >= 47 && cue <= 71) 
            || (cue >= 124 && cue <= 160) 
            || (cue >= 172 && cue<=233) 
            || (cue >= 275 && cue <= 320) 
            || (cue >= 335 && cue <= 426) 
            || (cue >= 439 && cue <= 472) 
            || (cue >= 495 && cue <= 630) 
            || (cue >= 642 && cue <= 707) 
            || (cue >= 731 && cue <= 760) 
            || (cue >= 776 && cue <= 799) 
            || (cue >= 815 && cue <= 837) 
            || (cue >= 836 && cue <= 887) 
            || (cue >= 963 && cue <= 1001) 
            || (cue >= 1030 && cue <= 1059)) {
                return true;
            } else {
                return false;
            }
        },

        // timerCallback() {
        //     if (this.$refs.movie.paused || this.$refs.movie.ended) 
        //       return 
        //     this.computeFrame()
        //     setTimeout(() => {
        //         this.timerCallback()
        //     }, 0)
        // },

        // computeFrame() {

        //     // if (this.$refs.movie.paused || this.$refs.movie.ended) {
        //     //   return;
        //     // }

        //     this.$ctx_tmp.drawImage(this.$refs.movie, 0, 0, this.width , this.height )
        //     let frame = this.$ctx_tmp.getImageData(0, 0, this.width , this.height )

        //     for (let i = 0; i < frame.data.length /4; i++) {
        //         let r = frame.data[i * 4 + 0]
        //         let g = frame.data[i * 4 + 1]
        //         let b = frame.data[i * 4 + 2]

        //         if (g > 100 && r < 112) 
        //             frame.data[i * 4 + 3] = 0
        //     }
        //     this.$ctx1.putImageData(frame, 0, 0)
        //     // window.requestAnimationFrame(this.computeFrame)
        //     // setTimeout(this.computeFrame, 0)
        // },

        onResize() {
            // TweenMax.set('.Media__canvas', { scale: (window.innerWidth/1080)*.74 })
        },
    }
    
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.border-enter-active {
    animation: bounce-in 2s;
}
.border-leave-active {
    transition: opacity 0.5s ease;
}
.border-leave-to {
    opacity: 0;
}

@keyframes bounce-in {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    62.5% {
        opacity: 0.5;
    }
    75% {
        opacity: 1;
    }
    87.5% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}

.InstructionsMobile {
    overflow hidden
    position absolute
    width 100%
    height 100%
    padding-top: 75px
    padding-bottom: 120px;
    background-image: url('~@/commons/images/bg_texture.jpg')
    background-size: cover
    z-index: 1000

    // display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    &__backbutton {
        position absolute;
        top: 75px;
        left: 10%;
        height: 32px;
        width: 32px;
        background-image: url('~@/commons/images/button_back.png')
        background-size: cover;
    }

    &__title {
        margin-bottom 18px
        font-size: 28px
        font-family: 'Ciutadella-Medium'
    }

    &__description {
        font-family: 'Ciutadella-Medium'
        font-size: 16px
    }

    .InstructionsMobile__logo {
        margin-bottom: 48px
        width: 35%
        justify-self: flex-start
        align-self: center
    }

    &__step {
        height: 80%
        width:80%
        margin: auto;
        align-self: center
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: stretch;
        justify-content: flex-start;
        text-align: center

        .help-img {
            width: auto;
            height: auto;
            max-height: 20%
            max-width: 80%
            align-self: center
        }

        &.first {
            .InstructionsMobile__logo {
                width: 40%;
            }
        }
    }
    
    &__title {
        // margin-bottom: 48px;
    }

    &__description {
        margin: 32px;
    }

    button {
        text-align: center;
        font-family: 'Ciutadella-Medium'
        font-size: 20px
        text-decoration: none;
        background-color: transparent;
        color: white;
        border-style: solid
        border-color: white
        padding: 1.5vh;
        display: inline-block;
        margin: 1.5vh 2px;
        border-radius: 28px;

        &.selected, &.next{
            color: #8D6C4C;
            background-color: white;
        }

        &.next {
            margin-bottom: 164px;
            justify-self: flex-end
            margin-top: auto;
        }
    }
}

.Media
    overflow hidden
    position absolute
    width 100vw
    height 100%
    color white
    background white

    &__credits {
        position absolute
        width 100%
        height 100%
        top: 0px;
        left: 0px;
        background-image: url('~@/commons/images/bg_texture.jpg')
        background-size: cover

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__camera {
        width: 100%;
        z-index: 0;
    }

    &__pausebutton {
        position absolute
        height 86vh
        width calc(86vh * 1.65)
        top 50%
        left 50%
        transform translate(-50%, -50%)
        z-index 10000
    }

    &__title {
        margin-bottom 18px
        font-size: 28px
        font-family: 'Ciutadella-Medium'
    }

    &__description {
        font-family: 'Ciutadella-Medium'
        font-size: 16px
    }

    &__step5 {
        // overflow hidden
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background-color transparent
        height 60%
        max-width: calc(50vh * calc(16 / 9));
        opacity 1 !important
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: stretch;
        justify-content: space-around;
        text-align: center
        z-index: 2;
    }

    &__pause {
        // overflow hidden
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background-color transparent
        height 60%
        max-width: calc(50vh * calc(16 / 9));
        opacity 1 !important
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: stretch;
        justify-content: space-around;
        text-align: center
        z-index: 2;
    }

    &__container    
        width 100%
        height 100%
        position relative
        display flex 
        justify-content center
        align-items center

    &__button 
        text-align: center;
        font-family: 'Ciutadella-Medium'
        font-size: 20px
        text-decoration: none;
        background-color: white;
        color: black;
        border-style: solid
        border-color: white
        padding: 16px;
        display: inline-block;
        margin: 18px 2px;
        border-radius: 28px;
        margin-top: 60px
        z-index 5000

    &__movie
        overflow hidden
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background-color transparent
        height 70%
        opacity 1 !important
        // border 4px solid green
        z-index: 1;
        aspect-ratio: 16 / 9;

    &__canvas
        overflow hidden
        position absolute
        background-color transparent
        // border 2px solid purple

    &__border 
        position absolute
        height 88%
        z-index: 2;

        aspect-ratio: 14.5 / 9;
        @supports not (aspect-ratio: 14.5 / 9) {
            width: calc(80vh * calc(14.5 / 9));
        }

        top 50%
        left 50%
        transform translate(-50%, -50%)

        img {
            height:100%; 
            width:100%;
        }

    &__frame
        position absolute
        height 182%
        z-index: 1;
        background-image: url('~@/commons/images/frame.png')
        background-repeat: no-repeat;
        background-size: cover;

        aspect-ratio: 14.5 / 9;
        @supports not (aspect-ratio: 14.5 / 9) {
            width: calc(80vh * calc(14.5 / 9));
        }

        top 50%
        left 50%
        transform translate(-50%, -49.5%)

        img {
            height:100%; 
            width:100%;
        }
        

    &__stopped
        width 100vw
        height 100vh
        background rgba(black, .9)
        position absolute
        top 0
        left 0
        display flex 
        align-items center
        justify-content center
        z-index 5

    &__cue 
        position absolute
        top 0 
        left 0
        color white
        background black
        padding 4px 8px

@media (orientation: portrait) {
    .Media {
        &__button {
            display: none
        }

        &__movie {
            display: none
        }

        &__border {
            display: none
        }
    }

    .landscape {
        display: none !important
    }
}

@media (orientation: landscape) {
    .InstructionsMobile {
        padding-top: 65px;

        &__step {
            flex-wrap: wrap;
            flex: 1 1 50%    
            justify-content: space-around;
            width: 84%

            &.first {
                justify-content: flex-start;
            }
            
            button {
                order: 2;
                width: 42%;
                align-self: center;
                margin: calc(3vh) 2px;
            }

            .help-img {
                order: 2;
                width: auto;
                height: auto;
                max-height: 55%
                max-width: 50%
                align-self: center
                margin-bottom: 28px
            }

            .next {
                order: 4;
                margin-bottom: auto !important
            }
        }

        &__logo {
            order: 1;
            width: 15% !important
        }

        &__title {
            order: 3;
            margin-top: 32px
            width: 42%;
            align-self: center;
        }

        &__description {
            order: 3;
            width: 42%;
            align-self: center;
            margin: 6px;
        }
    }
}

@media (orientation: landscape) and (max-height: 420px) {
    #interactive-header {
        display: none;
    }

    .InstructionsMobile {
        padding-top: 32px;

        &__backbutton {
            position absolute;
            top: 32px;
            left: 8%;
            height: 32px;
            width: 32px;
            background-image: url('~@/commons/images/button_back.png')
            background-size: cover;
        }
    }
}
</style>